import React from 'react'
import { Row, styled } from '@tools/wr-catalog-base'

export const ContainerRow = styled(Row)`
  margin-top: 1rem;
  position: relative;
  z-index: 10;

  button {
    width: auto;
    padding: 13px 10px;
  }

  .dropdown-input {
    text-align: left;
  }

  > div + div {
    flex-grow: 0;
    flex-basis: auto;
  }
`
